export default __webpack_public_path__ + "images/LP.9ba9050.png";